/**
 * Méga-menu / dropdown : image colonne droite suit le survol ou le focus des sous-liens
 * (data-massin-hover-* rendus via snippets/massin-nav-hover-media-attrs.liquid)
 */
(function () {
  function bindPanel(panel) {
    if (panel.dataset.massinSubmediaBound === '1') return;
    panel.dataset.massinSubmediaBound = '1';

    var media = panel.querySelector('.dropdown__media');
    var img = panel.querySelector('.dropdown__media-img');
    if (!media || !img) return;

    var defaultSrc = media.getAttribute('data-massin-default-src') || '';
    var defaultAlt = media.getAttribute('data-massin-default-alt') || '';

    if (!defaultSrc) {
      defaultSrc = img.src;
      defaultAlt = img.getAttribute('alt') || '';
    }

    var sel = 'a[data-massin-hover-src], summary[data-massin-hover-src]';

    function applyFromEl(el) {
      if (!el) return;
      var src = el.getAttribute('data-massin-hover-src');
      if (!src) return;
      var alt = el.getAttribute('data-massin-hover-alt');
      img.removeAttribute('srcset');
      img.sizes = '';
      img.src = src;
      if (alt) img.setAttribute('alt', alt);
    }

    function reset() {
      if (!defaultSrc) return;
      img.removeAttribute('srcset');
      img.sizes = '';
      img.src = defaultSrc;
      if (defaultAlt) img.setAttribute('alt', defaultAlt);
    }

    panel.addEventListener('mouseover', function (e) {
      var t = e.target.closest(sel);
      if (!t || !panel.contains(t)) return;
      applyFromEl(t);
    });

    panel.addEventListener('focusin', function (e) {
      var t = e.target.closest(sel);
      if (!t || !panel.contains(t)) return;
      applyFromEl(t);
    });

    panel.addEventListener('mouseleave', function () {
      reset();
    });

    panel.addEventListener('focusout', function (e) {
      if (!panel.contains(e.relatedTarget)) reset();
    });

    var details = panel.closest('details');
    if (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) reset();
      });
    }
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('.massin-nav-dropdown-panel').forEach(bindPanel);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (ev) {
    init(ev.target);
  });
})();
